import short from 'short-uuid';

const encode = (uuid: string) =>
  short(short.constants.flickrBase58, { consistentLength: false }).fromUUID(uuid);

const decode = (shortUuid: string) => short(short.constants.flickrBase58).toUUID(shortUuid);

export default { encode, decode };
